import { render } from "./TaiXeDoXang.vue?vue&type=template&id=8929f676&scoped=true"
import script from "./TaiXeDoXang.vue?vue&type=script&lang=js"
export * from "./TaiXeDoXang.vue?vue&type=script&lang=js"

import "./TaiXeDoXang.vue?vue&type=style&index=0&id=8929f676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8929f676"]])

export default __exports__